import React, { useState } from "react";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const handleNavClick = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-zinc-200/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-zinc-900 text-white font-heading font-bold text-sm tracking-tight group-hover:bg-blue-700 transition-colors duration-300">
            MS
          </span>
          <span className="font-heading font-semibold text-zinc-900 tracking-tight text-base md:text-lg">
            My Smart Delegate
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(link.href);
              }}
              className="text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            data-testid="header-cta-button"
            onClick={() => handleNavClick("#contact")}
            className="rounded-full bg-zinc-900 hover:bg-blue-700 text-white px-5 h-10 font-medium transition-all duration-300 active:scale-[0.98]"
          >
            Get in touch
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-lg border border-zinc-200 text-zinc-900 hover:bg-zinc-100 transition-colors"
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-nav"
          className="md:hidden border-t border-zinc-200 bg-white"
        >
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="px-3 py-3 rounded-lg text-base font-medium text-zinc-700 hover:bg-zinc-100 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <Button
              data-testid="mobile-cta-button"
              onClick={() => handleNavClick("#contact")}
              className="mt-2 w-full rounded-full bg-zinc-900 hover:bg-blue-700 text-white h-11 font-medium"
            >
              Get in touch
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
